import { createContext, useContext } from 'react';

/** What the surface hosting the assistant panel can do. */
export interface AssistantSurface {
  /**
   * Whether draft cards may save records outside proposals (packing lines,
   * contacts, recordings…). False inside the Salesforce-embedded editor, whose
   * token opens only the proposal and the assistant: those cards hand off to
   * the chat in BCE Cloud instead.
   */
  readonly savesRecords: boolean;
}

const FULL_APP: AssistantSurface = { savesRecords: true };

export const AssistantSurfaceContext = createContext<AssistantSurface>(FULL_APP);

/** The surface the assistant panel is running on. */
export function useAssistantSurface(): AssistantSurface {
  return useContext(AssistantSurfaceContext);
}
